import { IUser } from "../types";

export const fetchSubscriptionType = (user: IUser) =>
  user.subscriptions.filter(
    (subscription) => subscription.status === "ACTIVE"
  )[0]?.type || "";
